import { FullContext } from '@forge/bridge/out/types';
const FALLBACK_LOCALE = 'en_US';
export const constructViewContext = (fullContext: FullContext) => {
    const { extension } = fullContext;
    return {
        locale: fullContext.locale,
        extension: {
            fieldId: extension.fieldId as string,
            renderContext: extension.renderContext as string,
            fieldValue: extension.fieldValue as string,
            issue: {
                type: extension.issue?.type as string,
                typeId: extension.issue?.typeId as string,
            },
            project: {
                id: extension.project?.id as string,
            },
        },
    };
};

export const constructViewModelFromPortalContext = (
    locale: string | undefined,
    fieldId: string,
    issueTypeId: string | undefined,
    projectId: string | undefined
) => {
    //replacing dash to underscore fixes problem with other locale format in Forge context.locale MS-194
    return {
        locale: locale?.replace('-', '_') || FALLBACK_LOCALE,
        extension: {
            fieldId,
            renderContext: 'portal-create',
            fieldValue: undefined,
            issue: {
                type: issueTypeId!,
                typeId: issueTypeId!,
            },
            project: {
                id: projectId!,
            },
        },
    };
};

export const getStringAfterLastChar = (str: string, char: string) => {
    const lastIndex = str.lastIndexOf(char);

    if (lastIndex === -1) {
        return str;
    }

    return str.substring(lastIndex + 1);
};
